import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import useTenancies from "features/tenancies";

import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import ImagesSection from "./components/ImagesSection";
import InfoSection from "./components/InfoSection";
import InfoSection2 from "./components/InfoSection2";
import FacilitiesSection from "./components/FacilitiesSection";
import ContactSection from "./components/ContactSection";

import PropertyOverview from "assets/properties/kgv/kgv-overview.jpg";
import imageMapJSON from "../KGV/components/imageMapJSON";
import ImageMapIsometrySection from "./components/ImageMapIsometrySection";

const Wrapper = styled.div`
	margin: 0 auto;
	padding: 0px 0px;
	background-color: #fef6e5;
	overflow: hidden;
`;

const Container = styled.div`
	max-width: 1120px;
	margin: 0 auto;
	padding: 0px 0px;
	background-color: white;
`;

const KGV2 = () => {
	const { t } = useTranslation();

	const propertyId = "63c9606a-baa0-4719-a39c-b77a2eea7b72";

	const { isTenanciesLoading, tenanciesData, loadTenanciesByPropertyId } = useTenancies();

	const contactSectionRef = useRef(null);
	const isometrySectionRef = useRef(null);
	const scrollToIsometrySection = () => {
		isometrySectionRef.current.scrollIntoView({ behavior: "smooth" });
	};

	useEffect(() => {
		loadTenanciesByPropertyId(propertyId);
	}, [loadTenanciesByPropertyId]);

	return (
		<Wrapper>
			<Container>
				<HeroSection buttonClick={scrollToIsometrySection} />
				<FeaturesSection />
				<ImagesSection />
				<InfoSection />
				<InfoSection2 />
				<div ref={isometrySectionRef}>
					<ImageMapIsometrySection 
						title={t("properties.skovstykket.ImageMapSection.title")}
						text={"Her kan du se et oversigtsbillede af Kong Georgs Vej. Klik på de forskellige bygninger for at se detaljer om lejemålene"}
						imageWidth={2560}
						imageMapJSON={imageMapJSON}
						tenancies={tenanciesData}
						loading={isTenanciesLoading}
						image={PropertyOverview}
					/>
				</div>
				<FacilitiesSection />
				<div ref={contactSectionRef}>
					<ContactSection />
				</div>
			</Container>
		</Wrapper>
	);
};

export default KGV2;
